import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { StorageService } from '../storage/storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket?: WebSocket;
  private messageSubject = new Subject<string>();
  private authToken;

  constructor(private storageService: StorageService) {
    this.authToken = this.storageService.get('token');
  }

  public connect(nis: string) {
    this.socket = new WebSocket(`${environment.websocketUrl}${nis}`);

    this.socket.onmessage = (event) => {
      this.messageSubject.next(event.data);
    };
    this.socket.onopen = () => {
      console.log('WebSocket connection opened');
      const authMessage = JSON.stringify({
        type: 'AUTH',
        token: this.authToken.token
      });
      this.socket?.send(authMessage);
    };
    this.socket.onclose = () => {
      console.log('WebSocket connection closed');
    };
    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  }

  public getMessages(): Observable<string> {
    return this.messageSubject.asObservable();
  }

  public disconnect() {
    if (!!this.socket) {
      this.socket.close();
    }
  }
}
